import { supabase } from '../services/supabase'

/**
 * Aktivite logu kaydet
 */
export const logActivity = async (userId, actionType, entityType = null, entityId = null, description = null, metadata = null) => {
  try {
    // IP adresini al (basit bir yöntem)
    const ipAddress = await fetch('https://api.ipify.org?format=json')
      .then(res => res.json())
      .then(data => data.ip)
      .catch(() => null)

    const { error } = await supabase
      .from('activity_logs')
      .insert({
        user_id: userId,
        action_type: actionType,
        entity_type: entityType,
        entity_id: entityId,
        description: description,
        metadata: metadata,
        ip_address: ipAddress,
      })

    if (error) {
      console.error('Activity log kaydedilemedi:', error)
    }
  } catch (error) {
    console.error('Activity log hatası:', error)
  }
}

/**
 * Giriş logu kaydet
 */
export const logLogin = async (userId, ipAddress = null, userAgent = null) => {
  try {
    const { data, error } = await supabase
      .from('login_logs')
      .insert({
        user_id: userId,
        ip_address: ipAddress,
        user_agent: userAgent,
        login_at: new Date().toISOString(),
      })
      .select()
      .single()

    if (error) {
      console.error('Login log kaydedilemedi:', error)
      return null
    }

    return data
  } catch (error) {
    console.error('Login log hatası:', error)
    return null
  }
}

/**
 * Çıkış logu güncelle
 */
export const logLogout = async (loginLogId, userId) => {
  try {
    const loginLog = await supabase
      .from('login_logs')
      .select('login_at')
      .eq('id', loginLogId)
      .single()

    if (loginLog.data) {
      const loginAt = new Date(loginLog.data.login_at)
      const logoutAt = new Date()
      const sessionDuration = Math.floor((logoutAt - loginAt) / 1000) // saniye

      const { error } = await supabase
        .from('login_logs')
        .update({
          logout_at: logoutAt.toISOString(),
          session_duration: sessionDuration,
        })
        .eq('id', loginLogId)

      if (error) {
        console.error('Logout log güncellenemedi:', error)
      }
    }
  } catch (error) {
    console.error('Logout log hatası:', error)
  }
}


